import axios from 'axios'
import { PageLocaleEnum } from 'common/enums/PageLocaleEnum'
import {
  SearchResponseInterface,
  SearchResultInterface,
} from 'common/types/search-interfaces'

export interface getWebsiteSearchProps {
  query?: string | null
  page?: string | null
  limit?: string | null
  locale?: PageLocaleEnum
}

export const getWebsiteSearch = async ({
  query,
  limit = '10',
  page = '1',
  locale = PageLocaleEnum.ENGLISH,
}: getWebsiteSearchProps): Promise<
  SearchResponseInterface<SearchResultInterface>
> => {
  const res = await axios.get('/api/dashboard/website/website-pages/search', {
    params: {
      query,
      limit,
      page,
      locale,
    },
  })
  return res.data
}
